let idCounter = 0;
export default (prefix) => {
    const id = ++idCounter;
    return `${prefix}-${id}`;
};
//# sourceMappingURL=uniqueId.js.map